import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { strings } from "../utils/strings.js";
import { getAllBlogs, deleteBlog } from "../utils/methods.js";
import BlogArrowIcon from "../component/Icons/blogsArrow.jsx";
import ModalScreen from "../component/modal.jsx";
import DeleteIcon from "../component/Icons/deleteIcon.jsx";


const Blogs = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogData = await getAllBlogs();
        console.log("Fetched Blogs:", blogData);
        setBlogs(blogData);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };
    fetchBlogs();
  }, []);

  const handleAddBlog = () => navigate(`/blog/edit/new`);

  const handleClickOpen = (blogId) => {
    setSelectedBlogId(blogId);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setSelectedBlogId(null);
  };

  const handleDeleteBlog = async () => {
    try {
      if (selectedBlogId) {
        await deleteBlog(selectedBlogId);
        setBlogs((prevBlogs) =>
          prevBlogs.filter((blog) => blog.id !== selectedBlogId)
        );
      }
      handleClose();
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  return (
    <div className="container px-6 py-6  ">
      <div className="flex justify-between mb-8">
        <p className="text-4xl font-semibold mt-14  text-blue-600 ">{strings["BlogPageTitle"]}</p>
      
        <button
          className="bgblue hover:shadow-xl bg-customblue hover:shadow-[#719eaf] rounded-lg px-4 py-3 mt-14  text-xl font-semibold text-white"
          onClick={handleAddBlog}
        >
          {strings["AddBlogsBtn"]}
        </button>
        
      </div>

{blogs.length === 0 ? (
  <h2 className="text-xl  text-gray-500 mt-[11rem] text-center">
    No blogs available
  </h2>
) : (



      <div className="grid  grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {blogs.map((blog) => (
          <div
            key={blog.id}
            className="border bg-white rounded-2xl p-4 shadow-md flex flex-col justify-between"
          >
            <img
              src={`${blog.blogImage}?t=${new Date().getTime()}`}
              alt={blog.title}
              className="h-[200px] object-cover  w-full rounded-md"
              onError={(e) => {
                e.target.onerror = null;
                
              }}
            />
            <p className="text-md font-semibold text-blue-500  pt-3">
              {blog.type}
            </p>
            <div className="flex justify-between py-3">
              <h2 className="text-2xl font-semibold mb-4">{blog.title}</h2>
              <BlogArrowIcon />
            </div>
            <div className="flex gap-x-2 w-full">
              <button
                className="border-blue-600 border-2 rounded-xl text-blue-600  font-semibold px-9 py-3 sm:w-full "
                variant="outlineArrow "
                classes="border-primary text-primary !w-full justify-center"
                onClick={() => navigate(`/blog/edit/${blog.id}`)}
              >
                {strings["blogEditBtn"]}
              </button>
              <button
                className="bg-customblue hover:bg-blue-700 px-9 py-3 sm:w-full  rounded-xl font-semibold text-white "
                classes="!w-full justify-center"
                onClick={() => handleClickOpen(blog.id)}
              >
                {strings["DeleteBtn"]}
              </button>
            </div>
          </div>
        ))}
      </div>
)}
      <ModalScreen
        open={openDialog}
        onClose={handleClose}
        onConfirm={handleDeleteBlog}
        title={strings["deleteTitle"]}
        description={strings["deleteDesc"]}
        confirmButtonText={strings["DeleteBtn"]}
        cancelButtonText={strings["cancelBtn"]}
        hideClass="hidden"
        icon={DeleteIcon}
      />
    </div>
  );
};

export default Blogs;
